import { Box } from '@mui/material';
import { ReactNode } from 'react';

export const EventItemCircle = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '54px',
        width: '54px',
        height: '54px',
        border: '1px solid #C4CFFF',
        borderRadius: '50%',
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  );
};
